import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.temperatureAvg.loading;
export const temperatureAvgErrorMessage = (state: RootState) =>
  state.temperatureAvg.error;
export const temperatureAvgDataResponse = (state: RootState) =>
  state.temperatureAvg.temperatureAvgResponse;
